"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Label = exports.Icon = exports.Header = exports.Content = void 0;

var _tokens = require("@superlogica/foundation/tokens");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = _interopRequireDefault(require("../Box"));

var _Title = _interopRequireDefault(require("../Text/Title"));

var Content = (0, _styledComponents.default)(_Box.default).attrs({
  paddingType: 'square',
  paddingSize: 'md',
  radius: 'xs'
}).withConfig({
  componentId: "sc-j14gmn-0"
})(["display:block;transition:0.2s all linear;border:1px solid transparent;border-top:none;height:0px;opacity:0;display:none;"]);
exports.Content = Content;
var Header = (0, _styledComponents.default)(_Box.default).attrs({
  bgColor: 'neutral0',
  border: 'sm',
  borderColor: 'neutral100',
  paddingType: 'square',
  paddingSize: 'sm',
  radius: 'xs'
}).withConfig({
  componentId: "sc-j14gmn-1"
})(["background:", ";display:block;cursor:pointer;transition:0.2s all linear;"], _tokens.colors.neutral0);
exports.Header = Header;
var Label = (0, _styledComponents.default)(_Title.default).attrs({
  size: 'body02'
}).withConfig({
  componentId: "sc-j14gmn-2"
})(["display:flex;"]);
exports.Label = Label;

var Icon = _styledComponents.default.i.withConfig({
  componentId: "sc-j14gmn-3"
})(["display:inline-flex;align-self:center;width:", "px;height:", "px;margin-right:", "px;transition:0.2s all linear;& svg{fill:", ";width:16px;height:16px;}&.right{position:absolute;right:0px;}"], _tokens.spacing.horizontal.xs, _tokens.spacing.vertical.xs, _tokens.spacing.horizontal.xxxs, _tokens.colors.neutral600);

exports.Icon = Icon;

var Wrapper = _styledComponents.default.div.withConfig({
  componentId: "sc-j14gmn-4"
})(["position:relative;display:block;&.accordion-open{", "{border-bottom-right-radius:0px;border-bottom-left-radius:0px;}", ".right{transform:rotate(180deg);}", "{height:auto;opacity:1;display:block;border-top-right-radius:0px;border-top-left-radius:0px;border-color:", ";}}"], Header, Icon, Content, _tokens.colors.neutral100);

exports.Wrapper = Wrapper;